/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { bignumberDependencies } from './dependenciesBignumber.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { largerDependencies } from './dependenciesLarger.generated';
import { largerEqDependencies } from './dependenciesLargerEq.generated';
import { smallerDependencies } from './dependenciesSmaller.generated';
import { smallerEqDependencies } from './dependenciesSmallerEq.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createRangeTransform } from '../../factoriesAny.js';
export var rangeTransformDependencies = {
  bignumberDependencies: bignumberDependencies,
  matrixDependencies: matrixDependencies,
  largerDependencies: largerDependencies,
  largerEqDependencies: largerEqDependencies,
  smallerDependencies: smallerDependencies,
  smallerEqDependencies: smallerEqDependencies,
  typedDependencies: typedDependencies,
  createRangeTransform: createRangeTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesRangeTransform.generated.js
// module id = 1490
// module chunks = 0